import { ShortcutInfo } from "@decisions/server/DecisionsFramework/Design/ShortcutInfo";
import classNames from 'classnames';

export function getShortcutFromKeyCode(e: React.KeyboardEvent) {
  const code = (e.keyCode as any) as keyof typeof keyCodeForShortcutEditor;
  return stripModifierKeys(keyCodeForShortcutEditor[code] || e.key); // fallback to something modern if we miss.
}

// TODO dedupe these with Editor.ts when we are generating types for FrontEnd

// TODO keyCode has been deprecated for some time... modernize this?
export const keyCodeForShortcutEditor = {
  8: 'back',
  13: 'Enter',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Esc',
  32: 'Space',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'Left',
  38: 'Up',
  39: 'Right',
  40: 'Down',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  96: 'NumPad0',
  97: 'NumPad1',
  98: 'NumPad2',
  99: 'NumPad3',
  100: 'NumPad4',
  101: 'NumPad5',
  102: 'NumPad6',
  103: 'NumPad7',
  104: 'NumPad8',
  105: 'NumPad9',
  106: 'Multiply',
  107: 'Add',
  109: 'Substract',
  110: 'Decimal',
  111: 'Divide',
  65: 'A',
  66: 'B',
  67: 'C',
  68: 'D',
  69: 'E',
  70: 'F',
  71: 'G',
  72: 'H',
  73: 'I',
  74: 'J',
  75: 'K',
  76: 'L',
  77: 'M',
  78: 'N',
  79: 'O',
  80: 'P',
  81: 'Q',
  82: 'R',
  83: 'S',
  84: 'T',
  85: 'U',
  86: 'V',
  87: 'W',
  88: 'X',
  89: 'Y',
  90: 'Z',
  48: 'D0',
  49: 'D1',
  50: 'D2',
  51: 'D3',
  52: 'D4',
  53: 'D5',
  54: 'D6',
  55: 'D7',
  56: 'D8',
  57: 'D9',
};

function stripModifierKeys(keyName: string) {
  if (!keyName) {
    return keyName;
  }
  return keyName.replace(/(Shift|Control|Alt)/g, '');
}

export function getShortcutString(value: ShortcutInfo) {
  // not truly what classNames is for, but it'll do the job:

  return classNames(
    {
      'Shift +': value.Shift,
      'Control +': value.Control,
      'Alt +': value.Alt,
    },
    value.KeyName
  );
}
